import { TFunction } from "i18next";
import LinkConstants from "../../../../constants/LinkConstants";

export type FaqAnswer =
	| { type: "text"; content: string }
	| {
			type: "paragraphWithListAndLink";
			intro: string;
			list: string[];
			midText: string;
			linkText: string;
			linkId: string;
			outro: string;
	  }
	| { type: "paragraph"; content: string };

export interface FaqItem {
	question: string;
	answer: FaqAnswer[];
}

export function getMcpFaqs(t: TFunction): FaqItem[] {
	return [
		{
			question: t("questions.0.question"),
			answer: [{ type: "text", content: t("questions.0.answer") }],
		},
		{
			question: t("questions.1.question"),
			answer: [
				{
					type: "paragraphWithListAndLink",
					intro: t("questions.1.answer.part1"),
					list: t("questions.1.answer.services", { returnObjects: true }),
					midText: t("questions.1.answer.part2"),
					linkText: t("questions.1.answer.linkText"),
					linkId: "contactUs",
					outro: t("questions.1.answer.part3"),
				},
			],
		},
		{
			question: t("questions.2.question"),
			answer: [{ type: "text", content: t("questions.2.answer") }],
		},
		{
			question: t("questions.3.question"),
			answer: [{ type: "text", content: t("questions.3.answer") }],
		},
		{
			question: t("questions.4.question"),
			answer: [{ type: "text", content: t("questions.4.answer") }],
		},
	];
}

export const handleAnswerLinkClick = (id: string) => {
	if (id === "contactUs") {
		window.open(LinkConstants.BRIA_MCP_CONTACT_URL, "_blank");
	}
};
